import '../../../node_modules/bootstrap/js/dist/collapse';
//import '../../../node_modules/bootstrap/js/dist/dropdown';
import '../../../node_modules/bootstrap/js/dist/modal';
//import '../../../node_modules/bootstrap/js/dist/tab';
//import '../../../node_modules/bootstrap/js/dist/carousel';

import Splide from '../../../node_modules/@splidejs/splide';
import { AutoScroll } from "../../../node_modules/@splidejs/splide-extension-auto-scroll";

window.Splide = Splide;
window.SplideAutoScroll = AutoScroll;

(function () {

  let initFloatingBanner = () => {
    const floatingBanner = document.querySelector('.grammy-floating-banner');

    if (!floatingBanner) {
      return;
    }

    let handleScroll = () => {
      if (window.scrollY >= 300) {
        floatingBanner.style.maxHeight = "200px";
      } else {
        floatingBanner.style.maxHeight = "0";
      }
    }

    document.addEventListener('scroll', handleScroll);
  }

  let pauseModalVideos = () => {
    const modals = document.querySelectorAll('.modal:has(iframe)');
    modals.forEach((modal) => {
      modal.addEventListener('hide.bs.modal', event => {
        let iframe = modal.querySelector('iframe');
        iframe.src = iframe.src;
      })
    });
  };

  document.addEventListener('DOMContentLoaded', initFloatingBanner);
  document.addEventListener('DOMContentLoaded', pauseModalVideos);
})();